import { stripePublishableKey } from './app'
const stripeConfig = {
  pk: stripePublishableKey,
  locale: 'en',
};

export default stripeConfig;
